export default "__VITE_ASSET__DY94fSCY__"